import { FC, ReactNode } from 'react';

export interface WbTabProps {
  children?: ReactNode;
  name: string;
  action?: () => void;
}

export const WbTab: FC<WbTabProps> = ({ children }) => {
  return <>{children}</>;
};
